<template>
  <div class="profile-project-card">
    <a class="content-container" target="_blank" :href="project.link">
      <h3>
        {{ project.title }}
      </h3>
      <p>{{ project.description }}</p>
      <a class="mini-link" target="_blank" :href="project.link"> </a>
    </a>
    <div v-if="edit" class="button-container">
      <button class="edit portfolio-button" @click="editProject">✏️</button>
      <button
        class="delete portfolio-button"
        @click="deleteProject(project.projectId)"
      >
        🗑️
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "ProfileProjectCard",
  props: {
    project: Object,
    index: Number,
    edit: Boolean,
  },
  watch: {
    edit: function () {
      var proj = document.getElementsByClassName("profile-project-card");
      var contentCont = document.getElementsByClassName("content-container");
      if (this.edit) {
        for (let i = 0; i < proj.length; i++) {
          proj[i].style.backgroundColor = "rgba(50, 50, 50, 0.5)";
          contentCont[i].style.filter = "blur(1px)";
          // proj[i].style.filter = "blur(0.5px)";
        }
      } else {
        for (let i = 0; i < proj.length; i++) {
          proj[i].style.backgroundColor = "rgba(218, 218, 218, 1)";
          proj[i].style.opacity = "1";
          contentCont[i].style.filter = "none";
          // proj[i].style.filter = "none";
        }
      }
    },
  },
  methods: {
    ...mapActions(["deleteUserPortfolioProject"]),

    editProject() {
      this.$router.push(`/prosjekter/rediger/${this.project.projectId}`);
    },

    async deleteProject(projectId) {
      await this.deleteUserPortfolioProject(projectId).catch((error) => {
        console.log("Kunne ikke slette prosjekt: ", error);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.profile-project-card {
  text-decoration: none;
  display: flex;
  justify-content: space-around;
  margin-right: 0.5em;
  width: 190px;
  min-height: 220px;
  margin-bottom: 2%;
  background-color: rgb(218, 218, 218);
  padding: 0 15px;

  &:hover {
    transform: translateY(-5px) scale(1.025) translateZ(0);
    transition-duration: 0.3s;
    background: rgba(#61a1cb, 0.5);
    box-shadow: 0 16px 36px rgba(#61a1cb, 0.5);
  }
}

.content-container {
  width: 190px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  text-align: center;
  word-wrap: break-word;
  text-decoration: none;
  & a {
    position: absolute;
    right: 5px;
    bottom: 5px;
    font-size: 1.75em;
  }
}

.button-container {
  position: absolute;
  display: flex;
  flex-direction: column;
  margin: 40px auto;
  // width: 66%;
  width: 150px;
  & button {
    // position:
  }
}

.portfolio-button {
  margin: 15px auto;
  width: 100%;
  border: 1px solid black;
  background-color: white;
  &:hover {
    background-color: var(--secondary-background-color);
  }
}

.github-picture {
  max-width: 75px;
}

// a::after {
//   content: "↗";
// }

.mini-link::after {
  content: "↗";
}

@media only screen and (max-width: 768px) {
  .profile-project-card {
    margin-right: 0;
  }
}
</style>